<template>
  <div class="ccui-app-container">
    <div class="ccui-advanced-search-wrapper ccui-clearfix">
      <el-search
        :formProp="formData"
        @search="searchItem"
        :isShowSearch="isShowSearch"
        class="ccui-highsearch"
        :selectClear="true"
        width="400px"
      >
        <div class="ccui-tab-wrapper">
          <el-button
            :type="isActive === index ? 'table-top-active' : 'table-top'"
            size="mini"
            v-for="(item, index) in focuses"
            :key="index"
            @click="changeTab(item.focus, index)"
          >
            <template v-if="item.focus === 'all' && totalNum !== null"
              >全部{{ isActive === 0 ? `(${totalNum})` : "" }}</template
            >
            <template v-else-if="item.focus === 'opened' && totalNum !== null"
              >已启用{{ isActive === 1 ? `(${totalNum})` : "" }}</template
            >
            <template v-else-if="item.focus === 'closed' && totalNum !== null"
              >已禁用{{ isActive === 2 ? `(${totalNum})` : "" }}</template
            >
          </el-button>
        </div>
        <div class="ccui-extend-btn">
          <el-button
            size="mini"
            type="primary"
            @click="jumpNew"
            icon="icon-ccui-add-sup"
            >新增信息</el-button
          >
        </div>
        <template slot="search">
          <el-input
            v-model="formData.userName"
            clearable
            searchLabel="用户名"
            placeholder="请输入用户名模糊查询"
          ></el-input>
          <el-input
            v-model="formData.demoName"
            clearable
            searchLabel="名称"
            placeholder="请输入名称模糊查询"
          ></el-input>
          <el-input
            v-model="formData.phone"
            clearable
            searchLabel="手机号"
            placeholder="请输入手机号模糊查询"
          ></el-input>
          <el-switch-component
            searchLabel="出生日期"
            v-model="formData.birthdayDate"
          >
            <el-date-picker
              v-model="value1"
              type="year"
              placeholder="请选择年份查询"
              leftName="按年"
              value-format="yyyy"
              :editable="false"
              @change="selectDate"
            >
            </el-date-picker>
            <el-date-picker
              v-model="value2"
              type="month"
              placeholder="请选择月份查询"
              leftName="按月"
              value-format="yyyy-MM"
              :editable="false"
              @change="selectDate"
            >
            </el-date-picker>
            <el-date-picker
              v-model="value3"
              type="date"
              placeholder="请选择日期查询"
              leftName="按日"
              value-format="yyyy-MM-dd"
              @change="selectDate"
            >
            </el-date-picker>
          </el-switch-component>
        </template>
        <el-input
          v-model="formData.userName"
          clearable
          searchLabel="用户名"
          placeholder="请输入用户名模糊查询"
          slot="searchItem1"
        ></el-input>
        <el-input
          v-model="formData.demoName"
          clearable
          searchLabel="名称"
          placeholder="请输入名称模糊查询"
          slot="searchItem2"
        ></el-input>
        <el-input
          v-model="formData.phone"
          clearable
          searchLabel="手机号"
          placeholder="请输入手机号模糊查询"
          slot="searchItem3"
        ></el-input>
        <el-switch-component
          searchLabel="出生日期"
          slot="searchItem4"
          class="ccui-switch-from"
        >
          <el-date-picker
            v-model="value1"
            type="year"
            placeholder="请选择年份查询"
            leftName="按年"
            value-format="yyyy"
            :editable="false"
            @change="selectDate"
          >
          </el-date-picker>
          <el-date-picker
            v-model="value2"
            type="month"
            placeholder="请选择月份查询"
            leftName="按月"
            value-format="yyyy-MM"
            :editable="false"
            @change="selectDate"
          >
          </el-date-picker>
          <el-date-picker
            v-model="value3"
            type="date"
            placeholder="请选择日期查询"
            leftName="按日"
            value-format="yyyy-MM-dd"
            @change="selectDate"
          >
          </el-date-picker>
        </el-switch-component>
      </el-search>
    </div>
    <div class="ccui-multifunctional-table-wrapper">
      <el-table
        ref="multipleTable"
        :data="tableData"
        :fit="true"
        :row-style="setRowClass"
        :cell-style="setStyle"
        border
        class="ccui-multifunctional-table"
        @select-all="handleCheckAllChange"
        @select="handleCheckChange"
        @selection-change="handleSelectionChange"
        @header-dragend="setTableTitleWidth"
        @sort-change="changeSort"
        max-height="20000"
      >
        <el-table-column type="selection" width="28" />
        <template v-for="(table, index) in tableTheadOptions">
          <el-table-column
            v-if="table.checked"
            :fixed="table.fixed || false"
            :key="index"
            :type="table.type"
            :label="table.label"
            :min-width="table.width"
            :prop="table.prop"
            :align="table.align || 'left'"
            :header-align="table.headerAlign || 'left'"
            :filters="table.filters"
            :filter-method="filterMethodList[table.filterMethodName]"
            :formatter="formatterList[table.formatterName]"
            :show-overflow-tooltip="true"
          >
            <!--            <template slot-scope="scope">{{ scope.row[table.prop] }} </template>-->
          </el-table-column>
        </template>

        <el-table-column label="操作" width="127" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="jumpDetail(scope.$index, scope.row)"
              >查看
            </el-button>
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="jumpEdit(scope.$index, scope.row)"
              >编辑
            </el-button>
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="handleDelete(scope.$index, scope.row)"
              >删除
            </el-button>
          </template>
          <template v-slot:header>
            <div class="ccui-multifunctional-table-wrapper-operation">
              <span>操作</span>
              <el-popover
                placement="right"
                popper-class="ccui-multifunctional-table-wrapper_setting__popover"
                trigger="click"
              >
                <el-checkbox
                  v-for="(e, i) in fixedTableThead"
                  :key="i"
                  :checked="e.checked"
                  disabled
                  class="ccui-popover-disabled"
                  >{{ e.label }}
                </el-checkbox>
                <el-button
                  size="mini"
                  type="primary-font-mini"
                  class="ccui-multifunctional-table-wrapper_setting__reset"
                  @click="resetTableColumn"
                  >重置</el-button
                >
                <div class="ccui-popover-line"></div>
                <draggable
                  :list="unfixedTableThead"
                  class="ccui-draggable"
                  @change="handleTableChange"
                >
                  <el-checkbox-group
                    v-for="(item, index) in unfixedTableThead"
                    v-model="item.checked"
                    :key="index"
                  >
                    <el-checkbox
                      :label="item"
                      :checked="item.checked"
                      :width="item.width"
                      :title="item.label"
                      @change="handleUpdate(item, index)"
                      >{{ item.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </draggable>
                <i
                  class="el-icon-s-tools ccui-multifunctional-table-wrapper_setting__icon"
                  slot="reference"
                ></i>
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="ccui-table-footer" v-show="isShowPagination">
        <div class="ccui-operation">
          <el-button
            v-show="isSelection"
            size="mini"
            type="default"
            @click="handleDelSelected"
            style="margin-right:10px"
            >批量删除</el-button
          >
          <el-export-button
            placement="bottom"
            @export-excel="handleExport"
            @export-pdf="handleExport('all')"
          >
          </el-export-button>
        </div>
        <div id="ccui-paging">
          <el-pagination
            :total="totalNum"
            :page-size="getLocalPageSize()"
            :current-page="pageNoCode"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
          <el-button
            class="ccui-pagination-btn"
            size="mini"
            type="default"
            @click="handleSizeChange('none')"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import featureMixin from "../mixins/singleTableTabPage.js";
export default {
  name: "singleTableTabPage-tab-item-list-all",
  mixins: [featureMixin],
  data() {
    return {
      isActive: 0,
      status: ""
    };
  },
  methods: {
    // note 跟踪面包屑
    setBreadcrumb() {
      this.$store.dispatch("setBreadcrumb", [
        {
          level: "level2",
          data: {
            name: "单表增删改查（多页签）",
            path: "/list-query/tab/item-list-all"
          }
        },
        {
          level: "level3",
          data: {
            name: "全部",
            path: "/list-query/tab/item-list-all"
          }
        }
      ]);
    }
  }
};
</script>
